module.exports = __webpack_public_path__ + "static/Montserrat-SemiBold-fb428a00b04d4e93deb4d7180814848b.ttf";